module.exports = "/assets/84a0fa4974bf43a0ebfb97b2aaaf9629.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FM.png
// module id = 2500
// module chunks = 0